export default __webpack_public_path__ + "static/media/personagens-black.3447108d.svg";